export default __webpack_public_path__ + "static/media/gmb-specials-empty.036c1806.svg";